<template>
  <div class="assign-review-members-list" :class="classes">
    <div v-for="reviewMember in reviewMembers" :key="reviewMember.id">
      <assign-review-members-list-item
        :review-member="reviewMember"
        :selected="isSelected(reviewMember)"
        @click="toggleSelection(reviewMember)"
      />
    </div>
  </div>
</template>

<script>
import AssignReviewMembersListItem from './AssignReviewMembersListItem';

export default {
  name: 'AssignReviewMembersList',
  components: { AssignReviewMembersListItem },
  props: {
    reviewMembers: {
      type: Array,
      required: true,
    },
    selectedIds: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['assign', 'unassign'],
  computed: {
    classes() {
      return {
        'single-col': this.reviewMembers.length <= 5,
      };
    },
  },
  methods: {
    isSelected(reviewMember) {
      return this.selectedIds.includes(reviewMember.id);
    },
    toggleSelection(reviewMember) {
      if (this.isSelected(reviewMember)) {
        this.$emit('unassign', reviewMember);
      } else {
        this.$emit('assign', reviewMember);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.assign-review-members-list {
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(2, minmax(200px, 1fr));

  &.single-col {
    grid-template-columns: minmax(200px, 1fr);
  }
}
</style>
